export default __webpack_public_path__ + "static/DB-2aa90f39ad623200b4111b68b592bb5d.jpg";